import React from "react";
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { Container } from "react-bootstrap";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import DsnGrid from "../../components/DsnGrid";
import TextTrigger from "../../animation/TextTrigger";
import FadeUpTrigger from "../../animation/FadeUpTrigger";

//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import BoxGallery from "../../components/box-gallery/BoxGallery";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
// import FJustifiedGallery from "../../components/justified-gallery/FJustifiedGallery";
import NextProject from "../../components/next/NextProject";
import { Helmet } from "react-helmet-async";

const Trickl = ({ data }) => {
  const nextData = getPortfolioItem(7);

  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - {data.title} </title>
        <link rel='canonical' href='/portolio/trickl' />
        <meta name="description" content={data.description} />
      </Helmet>

      {/*Start Header Half*/}
      <HeaderHalf
        heroContent={data}
        parallax={{ yPercent: 30, scale: 1.1 }}
        overlay={data.overlay}
        href="#"
      >
        <strong className="color-heading">London Hydro</strong>{" "}
      </HeaderHalf>
      {/*End Header Half*/}

      {/*Start Info Project*/}
      <Container className="section-margin">
        <TitleCover>The Ask</TitleCover>
        <TextTrigger duration={0.8} stagger={0.1}>
          {(ref) => (
            <h2 className="title-section" ref={ref}>
              The Ask
            </h2>
          )}
        </TextTrigger>
        <FadeUpTrigger>
          {(ref) => (
            <>
              <p className="mt-20" ref={ref}>
                Through its green initiatives, London Hydro has implemented a number of pilot programs to help customers act on real-time energy tips and tools to reduce or shift home energy usage. Trickl is an energy management app that provides users with the energy usage data of their household to make informed decisions on energy cost and consumption.
              </p>
              <p className="mt-20" ref={ref}>
                London Hydro engaged Devlift to create the user experience and complete the
                front-end development of the new Trickl app, Trickl+. London Hydro’s objectives were to enhance the user experience, offer more insights into their usage and increase communication
                with more smart-home devices to take advantage of consumption information.

              </p>
            </>
          )}
        </FadeUpTrigger>
      </Container>
      {/*End Info Project*/}

      {/*Start Gallery List*/}
      <BoxGallery
        className="section-margin"
        col={3}
        colMobile={1}
        colGap={0}
        rowGap={0}
        images={[
          {
            src: "/assets/img/project/trickl/Trickl-Cost.svg",
            caption: "Trickl Cost",
          },
          {
            src: "/assets/img/project/trickl/Trickl-Device.svg",
            caption: "Trickl Device",
          },
          {
            src: "/assets/img/project/trickl/Trickl-Energy.svg",
            caption: "Trickl Energy",
          },
        ]}
      />
      {/*End Gallery List*/}

      {/*Start Box Info With Image*/}
      <BoxImageVertical
        src="/assets/img/project/trickl/Trickl-Solution.svg"
        className="section-margin"
        overlay={0}
      >
        <FadeUpTrigger>
          {(ref) => (
            <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
              <TitleCover>The Solution</TitleCover>
              <h2 className="title-section border-line-left" ref={ref}>
                The Solution
              </h2>
              <p ref={ref}>
                With aggressive deadlines, Devlift’s fast and fluid UX design process allowed the team to
                create interactive navigation prototypes making it possible for quick adjustments and iterations after the review and testing phase.
              </p>
              <p ref={ref}>
                Devlift streamlined components and created a number
                of recognizable design patterns, with clear visual hierarchy and consistency between
                screens, while allowing for personalization and a tailoring of the experience to the
                individual user’s household needs.
              </p>
              <p ref={ref}>
                Together with London Hydro, Devlift was able to create a solution that would not only help users
                lower energy consumption but also educate customers, driving them to save money, and make
                a positive environmental impact.

              </p>
              {/* <div className="button-box" ref={ref}>
                <ButtonDefault
                  text="View project"
                  icon={faAngleRight}
                  href="#0"
                />
              </div> */}
            </DsnGrid>
          )}
        </FadeUpTrigger>
      </BoxImageVertical>
      {/*End  Box Info With Image*/}

      {/* <FJustifiedGallery
        rowHeight={300}
        className="section-margin"
        images={[
          { src: "/assets/img/project/project2/6.jpg", caption: "CAPTION #1" },
          { src: "/assets/img/project/project2/7.jpg", caption: "CAPTION #2" },
          { src: "/assets/img/project/project2/8.jpg", caption: "CAPTION #3" },
          { src: "/assets/img/project/project2/9.jpg", caption: "CAPTION #4" },
          { src: "/assets/img/project/project2/10.jpg", caption: "CAPTION #5" },
          { src: "/assets/img/project/project2/11.jpg", caption: "CAPTION #6" },
          { src: "/assets/img/project/project2/12.jpg", caption: "CAPTION #7" },
        ]}
      /> */}

      <NextProject heroContent={nextData} overlay={nextData.overlay} />
    </React.Fragment>
  );
};

export default Trickl;
